import React from 'react';
import {Banner} from 'app/components/banner/Banner';
import {Notifications} from '@mui/icons-material';
import {useDispatch, useSelector} from 'react-redux';
import {createSelector} from 'reselect';
import {askForEntityPushFinished, updateNotificationNoSupportBanner} from 'app/actions/currentUserActions';
import styled from 'styled-components';
import {selectCollapsedAppBar} from 'app/hooks/reduxCreateSelectorHooks';
import {getUserAgentData} from 'app/helpers/helpers';
import {AppPromoBanner} from 'app/components/banner/AppPromoBanner';
import {APPLE_APP_STORE_URL} from 'app/components/banner/notificationVars';

const SCBanner = styled(Banner)`
  position: fixed;
  width: 100%;
  z-index: 20;
  top: ${props => (props.collapsedAppBar ? '2.625rem' : '7.125rem')}; // AppBarHeight 72px + TabBarHeight 42px
  transition: top 0.3s;
`;

const selectFollowPush = createSelector(
  state => state.currentUser,
  currentUser => {
    return {
      askForPush: currentUser.newFollow.askForPush,
      entity: currentUser.newFollow.entity,
    };
  }
);

const PromoBanner = () => {
  const {askForPush, entity} = useSelector(selectFollowPush);
  const {deviceType, platform} = getUserAgentData();
  const snippet = entity?.name ? `Du folgst jetzt ${entity?.name}. ` : '';

  const collapsedAppBar = useSelector(selectCollapsedAppBar);
  const dispatch = useDispatch();

  const icon = <Notifications color={'secondary'} />;

  const handleClose = () => {
    dispatch(askForEntityPushFinished());
    dispatch(updateNotificationNoSupportBanner());
  };

  if (typeof window === 'undefined') {
    return null;
  }

  // Desktop-Banner
  if (deviceType === 'desktop') {
    const primaryAction = {
      label: 'Verstanden',
      action: handleClose,
    };
    const secondaryAction = null;
    const text =
      snippet +
      'Dein Browser unterstützt keine Push-Benachrichtigungen. Installiere einen unterstützten Browser, wie Google Chrome oder Firefox.';

    return (
      <SCBanner
        collapsedAppBar={collapsedAppBar}
        open={askForPush}
        text={text}
        icon={icon}
        primaryAction={primaryAction}
        secondaryAction={secondaryAction}
      />
    );
  } else {
    const handleAppStoreLink = () => {
      window.open(APPLE_APP_STORE_URL, '_blank');
      dispatch(askForEntityPushFinished());
      dispatch(updateNotificationNoSupportBanner());
    };

    let primaryAction = {label: 'App Store öffnen', action: handleAppStoreLink};

    if (platform !== 'iOS') {
      primaryAction = {label: 'Verstanden', action: handleClose};
    }

    const text = snippet + 'Installiere die App aus dem App Store, um Push-Benachrichtigungen zu erhalten.';
    return (
      <AppPromoBanner
        collapsedAppBar={collapsedAppBar}
        open={askForPush}
        text={text}
        onClose={handleClose}
        primaryAction={primaryAction}
      />
    );
  }
};

export {PromoBanner};
